/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { hasRole } from 'linced-app/utils/roles';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import Scopes from '@linc-technologies/linced-common/enums/scopes';
import Staff from '@linc-technologies/linced-common/enums/roles/staff';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class HomeController extends Controller {
  @service
  session;

  @service
  options;

  @service
  permissions;

  @service
  roles;

  @service
  router;

  Jurisdiction = Jurisdiction;
  Scopes = Scopes;

  @optionAlias('hero:lock:milestones')
  milestonesLocked;

  @computed('router.currentRouteName')
  get currentRoute() {
    return this.get('router.currentRouteName').split('.').slice(0, 2).join('.');
  }

  @optionAlias('notifications:sms:enable')
  smsEnabled;

  @optionAlias('notifications:sms:enableAdminBulkSend')
  bulkSmsEnabled;

  @computed('session.scopes.[]')
  get bulkSmsAllowed() {
    return this.permissions.meet('urn:linced:organisation:role:admin');
  }

  @hasRole(Staff.APPROVE_ROLL_RETURNS)
  canApproveRollReturns;

  @action
  noop() {}
}
